import './index.sass';

export default () => {
 // $('.js-input-creditor').length && Creditor();
}